import {useEffect, Dispatch} from 'react';
import {useSelector} from 'react-redux';

import {selectManageWisbit} from 'store/selectors';
import {initiateWisbit} from 'containers/WisbitPage/redux/actions';

import {WisbitItem} from './types';
import {loadWisbitsThunk} from './redux/thunks';
import {ThunkActionType} from 'store/types';
import {WisbitActionTypes} from 'containers/WisbitPage/types';

type HookActionType = ThunkActionType | WisbitActionTypes;

type HookType = (dispatch: Dispatch<HookActionType>) => {
  loading?: boolean;
  data?: WisbitItem[];
};

export const useLoadWisbit: HookType = dispatch => {
  const {data, loading} = useSelector(selectManageWisbit);

  useEffect(() => {
    dispatch(loadWisbitsThunk());
    dispatch(initiateWisbit());
  }, [dispatch]);

  return {loading, data};
};
